export enum EventTypeEnum {
    BRIEFING = 'BRIEFING',
    ROUNDTABLE = 'ROUNDTABLE',
    TRAINING = 'TRAINING',
    NETWORKING_EVENT = 'NETWORKING_EVENT',
    WORKSHOP = 'WORKSHOP',
    JOB_FAIR = 'JOB_FAIR',
    CONFERENCE_SPONSORSHIP ='CONFERENCE_SPONSORSHIP'
}
